module.exports = __webpack_public_path__ + "img/HZ-G1515.431d43a3.jpg";